import { Outlet } from 'react-router-dom'

export const handle = {
  title: `Calls`,
  breadcrumb: `Calls`,
} as { breadcrumb: string }

export default function Calls(): React.ReactElement {
  return <Outlet />
}
